import React from 'react'
import { Card } from 'antd'
import styles from './index.scss'

const GuessLayout = ({ title, children }) => {
  return (
    <Card bordered={false} className={styles.card}>
      <div className={styles.title}>
        <span>{title}</span>
      </div>
      <div className="body">
        {[].concat(children).map((com, idx) => (
          <div key={`gi-${idx}`} className={styles.container}>
            {com}
          </div>
        ))}
      </div>
    </Card>
  )
}

export default GuessLayout
